import { Skeleton, Flex } from "antd";
import { useLocation, useParams } from "react-router-dom";
import { useMemo, useState } from "react";
import { useIntl } from "react-intl";
import useGetCurrentUserPermissionScope from "~hooks/useGetCurrentUserPermissionScope";
import { useHandlePagination } from "~hooks/useHandlePagination";
import FilterPanel from "./FilterPanel";
import SeasonTable from "./SeasonTable";
import Page from "../../../Common/Page";

const CompetitionSeasonList = () => {
  const {formatMessage} = useIntl();
  const { state } = useLocation();
  const [searchText, setSearchText] = useState(state?.seasonName || "");
  const [statusFilter, setStatusFilter] = useState(state?.seasonStatus || "ACTIVE");
  const { competitionId: pageCompetitionId } = useParams();

  const {
    pageSize,
    currentPage,
    handlePaginationChange,
    pageSizeOptions
  } = useHandlePagination(50, 1, [50, 100, 500, 1000]);

  const { data: scopeData, isLoading } = useGetCurrentUserPermissionScope();
  const { scope, resources } = scopeData || {};

  const competition = resources?.competitions?.[pageCompetitionId];
  const competitionSeasons = useMemo(() => {
    const seasonResources = resources?.seasons || {};

    for (const { competitions } of (scope?.leagueTree || [])) {
      for (const { competitionId, seasonIds } of competitions) {
        if (competitionId === pageCompetitionId) {
          return seasonIds.map((seasonId) => seasonResources[seasonId]);
        }
      }
    }

    return [];
  }, [scope?.leagueTree, resources?.seasons, pageCompetitionId])

  const filteredSeasons = useMemo(
    () => competitionSeasons.filter(({ status, nameLocal }) => {
      if (statusFilter !== "ALL" && status !== statusFilter) {
        return false;
      }

      if (searchText && !nameLocal?.toLowerCase()?.includes(searchText.toLowerCase())) {
        return false;
      }

      return true;
    }),
    [competitionSeasons, statusFilter, searchText],
  );

  const Title = () => {
    if (isLoading) {
      return <Skeleton.Input active={true} />;
    }

    return `${competition?.nameLocal}`;
  };

  return (
    <Page
      title={<Title/>}
      tabTitle={formatMessage(
        {id: "pageTitles.organization.competition.seasons"},
        {competitionName: competition?.nameLocal},
      )}
    >
      <Flex vertical gap={8}>
        <FilterPanel
          searchText={searchText}
          setSearchText={setSearchText}
          handleStatus={setStatusFilter}
          status={statusFilter}
        />
        <SeasonTable
          loading={isLoading}
          seasonList={filteredSeasons}
          pageSize={pageSize}
          currentPage={currentPage}
          handlePaginationChange={handlePaginationChange}
          pageSizeOptions={pageSizeOptions}
        />
      </Flex>
    </Page>
  );
};

export default CompetitionSeasonList;
